(function () {
  'use strict';

  angular
      .module('tfc.Toast')
      .provider('Toast', ToastProvider);

  // @ngInject
  function ToastProvider() {
    // true is a special value that means to use 'translateFilter' if it exists
    var translator = true;
    // Whether the developer has called ToastProvider.useTranslate.
    // If it's called more than once, it's probably a bug.
    var calledUseTranslate = false;
    var typeDefaults = {
      success : {
        delay : 2000
      },
      info : {
        delay : 5000
      },
      warn : {
        delay : 10000
      },
      error : {
        delay : false // never hide automatically
      }
    };

    function checkType(type) {
      if (!typeDefaults.hasOwnProperty(type)) {
        throw new Error('Invalid toast level [' + type + ']');
      }
    }

    function checkDelay(delay) {
      if (typeof delay !== 'Boolean' && isNaN(delay)) {
        throw new Error('Invalid delay [' + delay + ']');
      }
    }

    /**
     * Sets how or whether to translate toast message texts and titles.
     * @param use How or whether to use a translator. Defaults to using 'translateFilter' if it exists. Can be:
     *            false - Don't use any translation mechanism. Will just return the text or title as is.
     *            String - The name of a service whose value is a function taking text and data.
     *            Function - A custom translation function taking text and data.
     */
    this.useTranslate = function (use) {
      if (calledUseTranslate) {
        console.warn('ToastProvider.useTranslate has already been called with [' + translator + '].',
            'This is probably a bug.');
      }
      calledUseTranslate = true;
      if (use === false || _.isFunction(use) || _.isString(use)) {
        translator = use;
      } else {
        throw new Error('Illegal useTranslate value');
      }
    };

    this.getDefaultDelay = function (type) {
      checkType(type);
      return typeDefaults[type].delay;
    };

    this.setDefaultDelay = function (type, delay) {
      checkType(type);
      checkDelay(delay);
      typeDefaults[type].delay = delay;
      return this;
    };

    this.$get = function ($rootScope, $injector, $timeout, $state, $log) {
      var messages = [];

      $rootScope.$on('$stateChangeSuccess', dismissIrrelevant);

      if (translator === true) {
        // auto-detect translateFilter, or turn it off
        if ($injector.has('translateFilter')) {
          translator = $injector.get('translateFilter');
        } else {
          $log.debug('translateFilter not present -- turning off Toast translations');
          translator = false;
        }
      }

      return {
        // Called when the user clicks the X button
        dismiss : dismiss,
        translate : translate,
        list : function () { return messages.slice(); },
        success : withAlertType('success', typeDefaults.success),
        info : withAlertType('info', typeDefaults.info),
        warn : withAlertType('warning', typeDefaults.warn),
        error : withAlertType('danger', typeDefaults.error)
      };

      function translate(text, data) {
        var fn;
        if (!translator) {
          return text;
        }
        if (_.isFunction(translator)) {
          fn = translator;
        } else if (_.isString(translator)) {
          if (!$injector.has(translator)) {
            throw new Error('Toast set to use [' + translator + '] for translation, but it does not exist. ' +
                "If you aren't using translations, you need to call ToastProvider.useTranslate(false).");
          }
          fn = $injector.get(translator);
          if (!_.isFunction(fn)) {
            throw new Error('Toast useTranslate service [' + translator + '] is not a function');
          }
        } else {
          // This should never happen unless we add a feature and forget to implement it here
          throw new Error('Unsupported useTranslate value [' + translator + ']');
        }
        return fn(text, data);
      }

      function withAlertType(alertType, defaults) {
        return function (title, text, config) {
          if (arguments.length === 1) {
            text = title;
            title = null;
            config = null;
          } else if (!_.isString(text)) {
            config = text;
            text = title;
            title = null;
          }

          config = _.defaults({}, config, defaults, {
            state : false
          });

          if (config.state === true) {
            config.state = $state.current.name;
          }

          checkDelay(config.delay);

          return postMessage(_.extend(config, {
            alertType : alertType,
            title : title,
            text : text,
            dismissed : false,
            quickFade : false
          }));
        };
      }

      function deleteMessage(message) {
        $timeout.cancel(message.$timeout);
        _.pull(messages, message);
      }

      function postMessage(message) {
        messages.push(message);

        if (message.delay !== false) {
          message.$timeout = $timeout(function () {
            deleteMessage(message);
          }, message.delay);
        }
        var dismissMessage = function () {
          deleteMessage(message);
        };
        return dismissMessage
      }

      function dismiss(message) {
        // quickFade makes it fade out quickly when the user dismisses the toast
        // TODO: There's probably a better way
        message.quickFade = true;
        // TODO: This is done asynchronously in the original -- make sure that's unnecessary
        $timeout(function () {
          deleteMessage(message);
        });
      }

      function dismissIrrelevant() {
        // slice because `dismiss` will mutate `messages`
        _.each(messages.slice(), function (message) {
          // dismiss every state-bound message whose state we've left
          if (message.state && !isInState(message.state)) {
            dismiss(message);
          }
        });
      }

      // returns whether we're in the given state or one of its children
      function isInState(stateName) {
        var state = $state.$current;
        do {
          if (state.self.name === stateName) {
            return true;
          }
          state = state.parent;
        } while (state);
        return false;
      }
    };
  }

})();
